import { Dialog } from '@base-ui-components/react/dialog';
import clsx from 'clsx';

import { twMerge } from '../../../../../utils/twMerge';

export interface Props extends Dialog.Backdrop.Props {}

export const Backdrop = ({ className, ...restProps }: Props) => {
  const backdropClass = twMerge(
    clsx('fixed inset-0 bg-background-overlay z-overlay', className),
  );
  return (
    <Dialog.Backdrop
      className={backdropClass}
      onClick={event => event.stopPropagation()}
      {...restProps}
    />
  );
};
